import { Alert, Button, Col, Form, Input, Modal, Row, Table, Tooltip } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { EditOutlined, DeleteOutlined, PlusOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';
import moment from 'moment';

function MeetingLocation() {
    const token = useSelector((state) => state.user.token);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [dataModal, setdataModal] = useState(null);
    const [form] = Form.useForm();
    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
        sorter: {
            order: 'desc',
            columnKey: 'meeting_location_id',
        }
    });
    const [modalType, setModalType] = useState("add");
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState(false);

    const titlePage = 'Meeting Location Data';
    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: "no",
            render: (id, record, index) => { ++index; return (page.pagination.current - 1) * page.pagination.pageSize + index },
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: "name",
            sorter: true,
        },
        {
            title: 'Address',
            dataIndex: 'address',
            key: "address",
        },
        {
            title: 'Created At',
            dataIndex: 'created_at',
            key: "created_at",
            sorter: true,
            render: (text, record) => record.created_at ? (<p>{moment(record.created_at).format('DD-MM-YYYY HH:mm:ss')}</p>) : "-"
        },
        {
            title: 'Updated At',
            dataIndex: 'updated_at',
            key: "updated_at",
            sorter: true,
            render: (text, record) => record.updated_at ? (<p>{moment(record.updated_at).format('YYYY-MM-DD HH:mm:ss')}</p>) : "-"
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
                <>
                    <Tooltip title="Detail">
                        <Button type="default" style={{ marginRight: 10 }} onClick={() => openModal('detail', record)}>
                            <UnorderedListOutlined />
                        </Button>
                    </Tooltip>
                    <Tooltip title="Edit">
                        <Button type="primary" style={{ marginRight: 10 }} onClick={() => openModal('edit', record)}>
                            <EditOutlined />
                        </Button>
                    </Tooltip>
                    <Tooltip title="Delete">
                        <Button type="primary" danger onClick={() => modalDeleteData(record)}>
                            <DeleteOutlined />
                        </Button>
                    </Tooltip>
                </>
            ),
        },
    ];

    useEffect(() => {
        const order = page.sorter?.order === "ascend" ? 'asc' : 'desc';
        const columnKey = page.sorter?.columnKey || 'meeting_location_id';
        getApi("GET", `/meetinglocation?search=${search}&page=${page.pagination.current}&limit=${page.pagination.pageSize}&sortBy=${columnKey}&order=${order}`, 'meetinglocation');
    }, [JSON.stringify(page), isAlert]);

    const getApi = (method, url, type) => {
        setLoading(true);
        const dataReq = {
            method,
            url,
            data: {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setData(res.data);
                setPage({
                    ...page,
                    pagination: {
                        ...page.pagination,
                        total: res.total_data
                    }
                });
            }
            setLoading(false);
        }).catch((e) => {
            setLoading(false);
            console.error(e.message);
        });
    }

    const postApi = async (method, url, values) => {
        setLoading(true);
        setIsAlert(false);
        const dataReq = {
            method,
            url,
            data: {
                data: values,
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        await apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setdataModal(null);
                setIsAlert(true);
                setTextAlert(res.message);
                closeModal();
            } else {
                modalError(res.message);
            }
            setLoading(false);
        }).catch((e) => {
            setLoading(false);
            console.error(e.message);
        });
    }

    const modalDeleteData = (record) => {
        Modal.confirm({
            title: 'NOTICE',
            content: 'Do you want to delete this record?',
            onOk: () => postApi('DELETE', `/meetinglocation/${record.meeting_location_id}`, null),
        });
    }

    const openModal = (type, data) => {
        setModalType(type);
        if (type === 'edit') {
            setdataModal(data);
            form.setFieldsValue({
                name: data.name,
                address: data.address,
                description: data.description,
            });
        } else if (type === 'detail') {
            setdataModal(data);
            form.resetFields();
        } else {
            form.resetFields();
            setdataModal(null);
        }
        setIsModal(true);
    };


    const onFinish = (values) => {
        if (dataModal && dataModal.meeting_location_id) {
            postApi("PUT", `/meetinglocation/${dataModal.meeting_location_id}`, values);
        } else {
            postApi("POST", '/meetinglocation', values);
        }
    }

    const closeModal = () => {
        setdataModal(null);
        setIsModal(false);
        form.resetFields();
    }

    const handleTableChange = (pagination, filters, sorter) => {
        setPage({ pagination, filters, sorter });
        if (pagination.pageSize !== page.pagination?.pageSize) {
            setData([]);
        }
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
    }

    return (
        <div>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>
            {isAlert && <Alert message={textAlert} type="success" banner closable afterClose={() => setIsAlert(false)} />}
            <h3>Meeting Location</h3>
            <Row>
                <Col span={8}>
                    <Search
                        placeholder="Search"
                        allowClear
                        enterButton="Search"
                        size="middle"
                        onSearch={searchData}
                    />
                </Col>
                <Col span={16} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button style={{ marginBottom: 10 }} type="primary" onClick={() => openModal('add', null)}>
                        <PlusOutlined />
                        <b style={{ marginLeft: 5 }}>Add</b>
                    </Button>
                </Col>
            </Row>
            <Table
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
                rowKey="meeting_location_id"
            />
            <Modal
                title={
                    modalType === "edit" ? "Edit Meeting Location" :
                        modalType === "detail" ? "Detail Meeting Location" :
                            "Add Meeting Location"
                }
                open={isModal}
                onOk={modalType === "detail" ? closeModal : form.submit}
                onCancel={closeModal}
                okText={modalType === "detail" ? "Close" : "Save"}
            >
                {modalType === "detail" ? (
                    <div>
                        <p><b>Name:</b> {dataModal?.name}</p>
                        <p><b>Address:</b> {dataModal?.address}</p>
                        <p><b>Description:</b> {dataModal?.desc || "-"}</p>
                        <p><b>Created At:</b> {moment(dataModal?.created_at).format("DD-MM-YYYY HH:mm:ss")}</p>
                        <p><b>Updated At:</b> {moment(dataModal?.updated_at).format("DD-MM-YYYY HH:mm:ss")}</p>
                    </div>
                ) : (
                    <Form form={form} layout="vertical" onFinish={onFinish}>
                        <Form.Item
                            name="name"
                            label="Location Name"
                            rules={[{ required: true, message: 'Location Name is required!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            name="address"
                            label="Address"
                        >
                            <Input.TextArea />
                        </Form.Item>
                        <Form.Item
                            name="desc"
                            label="Description"
                        >
                            <Input.TextArea />
                        </Form.Item>
                    </Form>
                )}
            </Modal>

        </div>
    );
}

export default MeetingLocation;
